import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyPriceTab from "./component";
import { getPartyPeshiVideo, setActiveTab, setHammerSwipe } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        auctionResponse,
        helperVideos,
        carHealth,
        priceBreakup
    },
    user: { userId }
}) => ({
    inspectionResponse,
    auctionResponse,
    helperVideos,
    carHealth,
    userId,
    priceBreakup
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setHammerSwipeConnect: setHammerSwipe,
    setActiveTabConnect: setActiveTab,
    getPartyPeshiVideoConnect: getPartyPeshiVideo
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyPriceTab);
